var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 38,
    viewBox: "0 0 49 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6389 10.3467H33.3086V23.1V28.9716H45.7261C47.4863 28.9716 48.8684 27.4632 48.7146 25.7096L48.559 23.9346C48.4233 22.3867 47.6923 20.9517 46.52 19.9319L46.388 19.817L42.3001 11.9618C41.7836 10.9693 40.7577 10.3467 39.6389 10.3467Z",
    fill: "#82BD54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23H45.4815",
    stroke: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.308 22.1003V10.3469V4C33.308 2.34315 31.9648 1 30.308 1H4C2.34315 1 1 2.34314 1 4V10.3469V22.1003M33.308 22.1003V28.9719H4C2.34314 28.9719 1 27.6287 1 25.9719V22.1003M33.308 22.1003H1",
    stroke: "#383434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.063 36.9996C13.9697 36.9996 16.3261 34.5838 16.3261 31.6038C16.3261 28.6238 13.9697 26.208 11.063 26.208C8.15621 26.208 5.7998 28.6238 5.7998 31.6038C5.7998 34.5838 8.15621 36.9996 11.063 36.9996Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4331 36.9996C41.3399 36.9996 43.6963 34.5838 43.6963 31.6038C43.6963 28.6238 41.3399 26.208 38.4331 26.208C35.5263 26.208 33.1699 28.6238 33.1699 31.6038C33.1699 34.5838 35.5263 36.9996 38.4331 36.9996Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/delivery-truck.8ba71557e1efb4a37163473ce9a8b00b.svg";
export { ForwardRef as ReactComponent };